<template>
  <ShopifyStockEdit v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyStockEdit>
  <OpenCartStockEdit v-else></OpenCartStockEdit>
</template>

<script>
import { ShopifyStockEdit, OpenCartStockEdit } from "./partials";
export default {
  name: "stock-edit",
  components: { ShopifyStockEdit, OpenCartStockEdit }
};
</script>
